/* eslint-disable no-shadow */
import { PaletteColorOptions, createTheme } from '@mui/material/styles';
import type {} from '@mui/x-data-grid/themeAugmentation';

type ExtendedPaletteColorOptions = PaletteColorOptions & {
  secondary?: string;
  secondaryLight?: string;
  accent?: string;
  accentLight?: string;
  grey?: string;
  mainLight?: string;
};

const brandColor: ExtendedPaletteColorOptions = {
  main: '#012438',
  mainLight: '#334f5f',
  light: '#057D99',
  secondary: '#049A8F',
  secondaryLight: '#06C5B7',
  accent: '#F9A620',
  accentLight: '#FCD28F',
  grey: '#00000080'
};

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 768,
      lg: 1000,
      xl: 1200,
      xxl: 1536
    }
  },
  spacing: 8,
  palette: {
    white: {
      main: '#FFFFFF'
    },
    brand: brandColor,
    greyInput: {
      main: '#0000000F'
    },
    font: {
      main: '#011723'
    },
    primary: {
      main: '#002E5F'
    },
    secondary: {
      main: '#057D99'
    },
    contrastThreshold: 4.5
  },
  typography: {
    fontFamily: "'Public Sans', 'Roboto', sans-serif",
    allVariants: {
      color: '#011723',
      fontWeight: 400
    },
    h1: {
      fontSize: '1.5rem'
    },
    h2: {
      fontSize: '1.2rem'
    },
    body1: {
      fontSize: '1.4rem'
    },
    body2: {
      fontSize: '1rem'
    }
  },
  components: {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          minHeight: '25rem'
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: ({ theme }) => ({
          '& .MuiOutlinedInput-root': {
            backgroundColor: theme.palette.greyInput.main,
            borderRadius: '4px 4px 0 0'
          },
          '& input': {
            fontSize: '1rem'
          },
          '& label': {
            fontSize: '1rem'
          },
          '& .MuiInputBase-input::placeholder': {
            fontSize: '1rem'
          },
          '& .MuiOutlinedInput-notchedOutline': {
            fontSize: '1rem',
            borderColor: 'rgba(0, 0, 0, 0.23)',
            borderWidth: '0 0 1px 0'
          }
        })
      }
    },
    MuiFormControl: {
      styleOverrides: {
        root: ({ theme }) => ({
          '& .MuiOutlinedInput-root': {
            backgroundColor: theme.palette.greyInput.main,
            borderRadius: '4px 4px 0 0'
          },
          '& input': {
            fontSize: '1rem'
          },
          '& label': {
            fontSize: '1rem'
          },
          '& .MuiInputBase-input::placeholder': {
            fontSize: '1rem'
          },
          '& .MuiOutlinedInput-notchedOutline': {
            fontSize: '1rem',
            borderColor: 'rgba(0, 0, 0, 0.23)',
            borderWidth: '0 0 1px 0'
          }
        })
      }
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: '0.875rem'
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          padding: '0.5rem 1.37rem',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none'
          },
          '&:focus': {
            boxShadow: 'none'
          },
          '&:active': {
            boxShadow: 'none'
          }
        }
      }
    },
    MuiAutocomplete: {
      styleOverrides: {
        listbox: {
          fontSize: '0.875rem'
        }
      }
    },
    MuiLink: {
      styleOverrides: {
        root: ({ theme }) => ({
          fontWeight: 600,
          color: theme.palette.brand.light,
          textDecoration: 'none'
        })
      }
    }
  },
  custom: {
    navbarWidth: '20rem'
  }
});

export default theme;
